export enum AppLinkSize {
  M = 'linkMedium',
  S = 'linkSmall'
}